import { render, staticRenderFns } from "./sku.tpl.vue?vue&type=template&id=da5571f6&scoped=true&lang=html&name=Swiper&"
import script from "./sku.js?vue&type=script&lang=js&"
export * from "./sku.js?vue&type=script&lang=js&"
import style0 from "./fc-sku/index.styl?vue&type=style&index=0&lang=stylus&"
import style1 from "./sku.styl?vue&type=style&index=1&id=da5571f6&lang=stylus&scoped=true&"
import style2 from "./resetvant.styl?vue&type=style&index=2&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5571f6",
  null
  
)

export default component.exports